import React, { useEffect, useRef, useState } from 'react';
import {
  Create,
  DateTimeInput,
  FormDataConsumer,
  required,
  SelectInput,
  TextInput,
  useDataProvider,
  AutocompleteInput,
} from 'react-admin';
import { columnStyles } from '../../styles';
import { eventStatus } from '../../utils/choices';
import { BaseForm } from '../../Components';
import { EventPlotForm } from '../../../src/Components/Forms';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import CustomLocationDescForm from 'Components/Forms/CustomLocationDesc';

// Material-UI adds an extra div around AutoCompleteInput that sets a flex-grow: 1
// which pushing the component to the left. In order to disable need another wrapper to overwrite it
const useStyles = makeStyles({
  root: {
    flexGrow: 0,
  },
});

const EventCreate = (props) => {
  const newProps = { ...props, customRedirect: '/event' };

  const { resource } = props;
  const form = columnStyles('column', '30vw');
  const autoCompleteStyle = useStyles();
  const [plots, setPlots] = useState([]);
  const [locations, setLocations] = useState([]);
  const [locDescription, setLocDescription] = useState();
  const [admins, setAdmins] = useState([]);
  const [plot, setPlot] = useState();
  const dataProvider = useDataProvider();

  useEffect(() => {
    dataProvider
      .getList('plot', {})
      .then(({ data }) => {
        const plotArray = data.map(({ id, name }) => ({ id, name }));
        setPlots(plotArray);
      })
      .catch((error) => {
        console.log(error);
      });

    dataProvider
      .getList('location', {})
      .then(({ data }) => {
        const locArray = data.map(({ id, name }) => ({ id, name }));
        const locDescArray = data.map(({ id, description }) => ({ id, description }));
        setLocations(locArray);
        setLocDescription(locDescArray);
      })
      .catch((error) => {
        console.log(error);
      });

    dataProvider
      .getList('admin', {})
      .then(({ data }) => {
        const adminArray = data.map(({ id, email, role }) => ({
          id,
          email,
          role,
        }));
        setAdmins(adminArray);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const onPlotChange = (event) => {
    dataProvider
      .getOne('plot', { id: event })
      .then(({ data }) => {
        setPlot(data);
      })
      .catch((error) => {
        console.log(error);
      });
    console.log({ plot });
  };

  const childRef = useRef();

  const handleChildMethod = (event) => {    
    const locDescFind = locDescription.find((loc) => loc.id === event);

    childRef.current.changeLocationDescription(locDescFind);
  };

  return (
    <Create title={`resources.${resource}.titles.create`} {...props}>
      <BaseForm {...newProps}>
        <div className={form.container}>
          <TextInput
            className={form.column}
            source="name"
            label="Event Title"
            validate={required()}
          />
          <div className={autoCompleteStyle.root}>
            <AutocompleteInput
              className={form.column}
              source="eventLocationId"
              choices={locations}
              shouldRenderSuggestions={(val) => val.trim().length > 0}
              validate={required()}
              onChange={handleChildMethod}
            />
          </div>
          <FormDataConsumer>
            {(formDataProps) =>
              <CustomLocationDescForm ref={childRef} {...formDataProps} />
            }
          </FormDataConsumer>
          <div className={autoCompleteStyle.root}>
            <AutocompleteInput
              className={form.column}
              source="plotId"
              choices={plots}
              shouldRenderSuggestions={(val) => val.trim().length > 0}
              validate={required()}
              onChange={onPlotChange}
            />
          </div>
          <div className={autoCompleteStyle.root}>
            <AutocompleteInput
              className={form.column}
              source="eventDirectorId"
              choices={admins}
              optionText="email"
              optionValue="id"
              shouldRenderSuggestions={(val) => val.trim().length > 0}
              validate={required()}
            />
          </div>
          <FormDataConsumer>
            {(formDataProps) => (
              <EventPlotForm plot={plot} {...formDataProps} />
            )}
          </FormDataConsumer>
          <DateTimeInput
            className={form.column}
            source="eventDate"
            validate={required()}
            parse={(dat) => {
              return moment.utc(dat).format('YYYY-MM-DDTHH:mm');
            }}
            format={(dat) => {
              if (dat) {
                return moment.utc(dat).utc().format('YYYY-MM-DDTHH:mm');
              }
              return null;
            }}
          />
          <SelectInput
            className={form.column}
            source="status"
            choices={eventStatus}
            validate={required()}
          />
          <TextInput
            className={form.column}
            source="eventCode"
            validate={required()}
          />
        </div>
      </BaseForm>
    </Create>
  );
};

export default EventCreate;
